import { Route, ArrowDown, ArrowUp, Flag } from "lucide-react"

export const statsData = [
  {
    value: "480 m",
    label: "Gesamtlänge",
    description: "Kartbahnen",
    icon: Route,
  },
  {
    value: "150 m",
    label: "Kartbahn",
    description: "Untergeschoss",
    icon: ArrowDown,
  },
  {
    value: "280 m",
    label: "Kartbahn",
    description: "Obergeschoss",
    icon: ArrowUp,
  },
  {
    value: "3000+",
    label: "Rennen",
    description: "gefahren",
    icon: Flag,
  },
]
